import { useLocation } from 'react-router-dom'
import { css, cx, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { Button, ButtonProps } from '@fable/components'
import { useSidebar, useTypedSelector, useActions } from '../../../../hooks'
import { BOOK_LIST_SAVE } from '../../constants'
import { FORM_TYPES } from '../../../auth/constants'

interface Props extends ButtonProps {
  className?: string
  book: Book
  keepButtonStyles?: boolean
}

export const ListButton = ({
  className,
  book,
  keepButtonStyles = false,
  negative = true,
  ...nativeProps
}: Props) => {
  const { pathname } = useLocation()
  const { nativeOverrides } = useTheme()
  const { onOpenSidebar } = useSidebar()
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { openAuthModal } = useActions()

  const handleOnClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()

    if (!isAuthenticated) {
      openAuthModal(FORM_TYPES.SIGN_UP, pathname)
    } else {
      if (!book) return
      onOpenSidebar(BOOK_LIST_SAVE, { book, bookId: book.id })
    }
  }

  return (
    <Button
      dataTestId="list-button"
      className={cx(
        !keepButtonStyles && nativeOverrides.buttonClear,
        css`
          pointer-events: auto;
          .fds-ui--icon {
            width: 22px;
          }
          svg {
            width: 100%;
            height: 22px;
          }
        `,
        className
      )}
      onClick={handleOnClick}
      icon="bookmark-outline"
      negative={negative}
      {...nativeProps}
    />
  )
}
